import { isValidEmail, isValidHttpUrl, isValidIsoDate } from "../../utilities";

export const ColumnTypeValues = [
	"Auto",
	"Boolean",
	// "Count",
	// "Created time",
	"Currency",
	"Date time",
	"Date",
	// "Duration",
	"Email",
	"Emoji reactions",
	// "Last modified time",
	"Link to record",
	"Multiline text",
	"Number",
	"Percent",
	"Person",
	"Progress bar",
	"Reaction",
	"Table",
	"Tag",
	"Text",
	"Time distance to now",
	"Time",
	"URL",
] as const;
export type ColumnType = (typeof ColumnTypeValues)[number];

export const disallowedInColumnHeaderSelection = new Set<ColumnType>([
	"Currency",
	"Email",
	"Link to record",
	"Multiline text",
	"Percent",
	"Table",
	"Time",
	"Time distance to now",
	"Emoji reactions",
]);

export const isPreviewableColumnType = (
	columnType: ColumnType | undefined
): columnType is "Multiline text" | "Table" =>
	columnType === "Multiline text" || columnType === "Table";

export const parseColumnType = (value: any): ColumnType => {
	const t = typeof value;
	switch (t) {
		case "boolean":
			return "Boolean";

		case "number":
			return "Number";

		case "string": {
			if (isValidHttpUrl(value)) {
				return "URL";
			} else if (isValidIsoDate(value)) {
				return "Date time";
			} else if (isValidEmail(value)) {
				return "Email";
			}
			return "Text";
		}

		default: {
			if (value instanceof URL) {
				return "URL";
			}

			if (value instanceof Date) {
				return "Date time";
			}

			return "Auto";
		}
	}
};
